//MainLayout.js
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import MenuComponent from '../Utils/Menu';

// Evita que el navegador sirva una versión vieja cacheada del fondo al reemplazar el archivo en el servidor.
const CACHE_BUST = Date.now();

const MainLayout = ({ children }) => {
    const [menuCollapsed, setMenuCollapsed] = useState(false);

    useEffect(() => {
        // Función para obtener el estado del menú desde localStorage
        const getMenuState = () => {
            const saved = localStorage.getItem('menuCollapsed');
            return saved ? JSON.parse(saved) : false;
        };

        // Establecer estado inicial
        setMenuCollapsed(getMenuState());

        // Escuchar cambios en localStorage
        const handleStorageChange = () => {
            setMenuCollapsed(getMenuState());
        };

        // Escuchar cambios en el localStorage
        window.addEventListener('storage', handleStorageChange);
        
        // También escuchar cambios directos (para cuando el cambio ocurre en la misma pestaña)
        const interval = setInterval(handleStorageChange, 100);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(interval);
        };
    }, []);

    
    const menuWidth = menuCollapsed ? 60 : 270;
    const backgroundImage = `/imagenes/background.png?v=${CACHE_BUST}`;


    return (
        <Box sx={{ display: 'flex' }}>
            <MenuComponent />
            
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    marginLeft: `${menuWidth}px`,
                    transition: 'margin-left 0.3s ease',
                    height: '100vh',
                    width: `calc(100vw - ${menuWidth}px)`,
                    overflow: 'auto',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundAttachment: 'fixed',
                    '@media (max-width: 768px)': {
                        marginLeft: menuCollapsed ? '60px' : '0px',
                        width: menuCollapsed ? 'calc(100vw - 60px)' : '100vw',
                    }
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default MainLayout;
//backgroundImage: `url(${appVar.gBackground})`,